//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class RepertoirePerformanceSearchOptions extends ItemBase {
    RepertoirePerformanceIDs: string[] = [];
    StudentIDs: string[] = [];
    RepertoireIDs: string[] = [];
    StartDate: string | null = null;
    EndDate: string | null = null;
    SearchText: string | null = null;
    HasActiveStudent: boolean | null = null;

    constructor(initializer?: Partial<RepertoirePerformanceSearchOptions>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "RepertoirePerformanceSearchOptions";
}
